import VueLib from 'vue'
import * as Sentry from '@sentry/browser'

import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {"dsn":"https:\u002F\u002F5733b9553c714a33a12cf1095435bfe7@o417190.ingest.sentry.io\u002F5372504","environment":"production","release":"release-production-202611041703","beforeBreadcrumb":(breadcrumb) => {
        const category = breadcrumb && breadcrumb.category
        if (
          (category === 'xhr' ||
            category === 'fetch' ||
            category === 'navigation') &&
          breadcrumb.data
        ) {
          ;['url', 'from', 'to'].forEach((key) => {
            if (typeof breadcrumb.data[key] === 'string') {
              breadcrumb.data[key] = breadcrumb.data[key]
                .split('#')[0]
                .split('?')[0]
            }
          })
        }
        return breadcrumb
      },"beforeSend":(event) => {
        if (event && event.request && typeof event.request.url === 'string') {
          event.request.url = event.request.url.split('#')[0].split('?')[0]
        }
        return event
      }}
  config.integrations = [
    new Dedupe({}),
    new ExtraErrorData({}),
    new ReportingObserver({}),
    new RewriteFrames({}),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
